import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _toArray from "@babel/runtime/helpers/toArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _get from 'lodash/get';
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import _isNil from 'lodash/isNil';
import _isObject from 'lodash/isObject';
import { classNames } from '../../../../utils/classname';
export function searchValueAtPath(obj, path, targetValue) {
  var pathSegments = path.split('.');
  function search(currentObj, segments) {
    if (!segments.length) {
      if (_isArray(currentObj) && currentObj.every(function (item) {
        return !_isObject(item);
      })) {
        return currentObj.includes(targetValue);
      }
      return _isEqual(currentObj, targetValue);
    }
    var _segments = _toArray(segments),
      firstSegment = _segments[0],
      restSegments = _segments.slice(1);
    if (_isArray(currentObj)) {
      return currentObj.some(function (item) {
        return search(item, segments);
      });
    }
    var nextObj = _get(currentObj, firstSegment);
    return search(nextObj, restSegments);
  }
  return search(obj, pathSegments);
}
export function filterItems(items, itemFilterKey, currentFilter, displayAllFilterValue) {
  if (_isEmpty(items) || _isNil(items)) {
    return [];
  }
  if (_isEmpty(currentFilter)) {
    return items;
  }
  if (currentFilter === displayAllFilterValue) {
    return items;
  }
  return items.filter(function (item) {
    return searchValueAtPath(item, itemFilterKey, currentFilter);
  });
}
export function createFilterValues(filters, items, itemsKey) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    filtersKey = _ref.filtersKey,
    _ref$displayAllFilter = _ref.displayAllFilterValue,
    displayAllFilterValue = _ref$displayAllFilter === void 0 ? null : _ref$displayAllFilter;
  if (_isEmpty(filters) || _isNil(items)) {
    return [];
  }
  var finalFilters = filters;
  if (!_isEmpty(filtersKey)) {
    finalFilters = filters.map(function (filter) {
      return _get(filter, filtersKey);
    }).filter(Boolean);
  }

  // ensure there is at least one item for for the filter
  finalFilters = finalFilters.filter(function (filter) {
    var filteredItems = filterItems(items, itemsKey, filter, displayAllFilterValue);
    return !_isEmpty(filteredItems);
  });
  if (!_isNil(displayAllFilterValue)) {
    return [displayAllFilterValue].concat(_toConsumableArray(finalFilters));
  }
  return finalFilters;
}
export function shouldHideFilterControls(filterValues, items, itemsKey) {
  var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref2$displayAllFilte = _ref2.displayAllFilterValue,
    displayAllFilterValue = _ref2$displayAllFilte === void 0 ? null : _ref2$displayAllFilte;
  if (_isEmpty(filterValues) || _isEmpty(items)) {
    return true;
  }
  if (_isEmpty(displayAllFilterValue) && !filterValues.includes(displayAllFilterValue)) {
    return filterValues.length <= 1;
  }
  if (filterValues.length === 2 && !_isEmpty(displayAllFilterValue) && filterValues.includes(displayAllFilterValue)) {
    var nonDisplayAllFilter = filterValues.find(function (filter) {
      return filter !== displayAllFilterValue;
    });
    // return true if the non displayAllFilter filters every single item
    return items.length === filterItems(items, itemsKey, nonDisplayAllFilter, displayAllFilterValue).length;
  }

  // return false if if there are two or more valid filters
  return filterValues.length < 2;
}
export function createFilterClassName(active) {
  var baseClassNames = {
    filter: true
  };
  if (active) {
    baseClassNames = _objectSpread(_objectSpread({}, baseClassNames), {}, {
      active: true
    });
  }
  return classNames(baseClassNames);
}